/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .file-input > label.file-input-label > input[type='file'] {
    display: none;
  }

  .file-input > label.file-input-label {
    margin: 0;
  }

  .file-input > .input-group-text {
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    text-align: center;
  }
`;
